import { IconType } from "react-icons";
import { GiBeachBag, GiClothes, GiGamepad, GiPencilBrush } from "react-icons/gi";
import { BiDrink } from "react-icons/bi";
import { MdEvent, MdOutlineHealthAndSafety } from "react-icons/md";
import { PiBaseballCapLight, PiBowlFood } from "react-icons/pi";
import { IoIosFootball } from "react-icons/io";
import { GrHomeRounded } from "react-icons/gr";
import { BsPrinter, BsTools } from "react-icons/bs";
import { FaUsb } from "react-icons/fa6";
import { FaPencilRuler } from "react-icons/fa";

export const categoryIcons: Record<string, IconType> = {
  Bags: GiBeachBag,
  Clothing: GiClothes,
  Drinkware: BiDrink,
  "Exhibitions & Events": MdEvent,
  "Food & Drink": PiBowlFood,
  "Fun & Games": IoIosFootball,
  Headwear: PiBaseballCapLight,
  "Health & Personal": MdOutlineHealthAndSafety,
  "Home & Living": GrHomeRounded,
  "Keyrings & Tools": BsTools,
  "Office Stationery": FaPencilRuler,
  "Leisure & Outdoors": GiGamepad,
  "Pens & Pencils": GiPencilBrush,
  "USB & Tech": FaUsb,
  Print: BsPrinter,
};
